import { asList2ho2pewtsfvv as asList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_ArraysJs.mjs';
import {
  charSequenceLength3278n89t01tmv as charSequenceLength,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
  charCodeAt1yspne1d8erbm as charCodeAt,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import {
  _Char___init__impl__6a9atx1csff5kwtduxl as _Char___init__impl__6a9atx,
  Char__compareTo_impl_ypi4mb3frsmupst9pih as Char__compareTo_impl_ypi4mb,
  toString3dhdjl9yf50de as toString,
  Char__toInt_impl_vasixd3jl92hthlhyn7 as Char__toInt_impl_vasixd,
} from '../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { captureStack1fzi4aczwc4hg as captureStack } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { contains2el4s70rdq4ld as contains } from '../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var HttpHeadersClass;
function HttpHeaders() {
  if (HttpHeadersClass === VOID) {
    class $ {
      constructor() {
        HttpHeaders_instance = this;
        this.f4v_1 = 'Accept';
        this.g4v_1 = 'Accept-Charset';
        this.h4v_1 = 'Accept-Encoding';
        this.i4v_1 = 'Accept-Language';
        this.j4v_1 = 'Accept-Ranges';
        this.k4v_1 = 'Age';
        this.l4v_1 = 'Allow';
        this.m4v_1 = 'ALPN';
        this.n4v_1 = 'Authentication-Info';
        this.o4v_1 = 'Authorization';
        this.p4v_1 = 'Cache-Control';
        this.q4v_1 = 'Connection';
        this.r4v_1 = 'Content-Disposition';
        this.s4v_1 = 'Content-Encoding';
        this.t4v_1 = 'Content-Language';
        this.u4v_1 = 'Content-Length';
        this.v4v_1 = 'Content-Location';
        this.w4v_1 = 'Content-Range';
        this.x4v_1 = 'Content-Type';
        this.y4v_1 = 'Cookie';
        this.z4v_1 = 'DASL';
        this.a4w_1 = 'Date';
        this.b4w_1 = 'DAV';
        this.c4w_1 = 'Depth';
        this.d4w_1 = 'Destination';
        this.e4w_1 = 'ETag';
        this.f4w_1 = 'Expect';
        this.g4w_1 = 'Expires';
        this.h4w_1 = 'From';
        this.i4w_1 = 'Forwarded';
        this.j4w_1 = 'Host';
        this.k4w_1 = 'HTTP2-Settings';
        this.l4w_1 = 'If';
        this.m4w_1 = 'If-Match';
        this.n4w_1 = 'If-Modified-Since';
        this.o4w_1 = 'If-None-Match';
        this.p4w_1 = 'If-Range';
        this.q4w_1 = 'If-Schedule-Tag-Match';
        this.r4w_1 = 'If-Unmodified-Since';
        this.s4w_1 = 'Last-Modified';
        this.t4w_1 = 'Location';
        this.u4w_1 = 'Lock-Token';
        this.v4w_1 = 'Link';
        this.w4w_1 = 'Max-Forwards';
        this.x4w_1 = 'MIME-Version';
        this.y4w_1 = 'Ordering-Type';
        this.z4w_1 = 'Origin';
        this.a4x_1 = 'Overwrite';
        this.b4x_1 = 'Position';
        this.c4x_1 = 'Pragma';
        this.d4x_1 = 'Prefer';
        this.e4x_1 = 'Preference-Applied';
        this.f4x_1 = 'Proxy-Authenticate';
        this.g4x_1 = 'Proxy-Authentication-Info';
        this.h4x_1 = 'Proxy-Authorization';
        this.i4x_1 = 'Public-Key-Pins';
        this.j4x_1 = 'Public-Key-Pins-Report-Only';
        this.k4x_1 = 'Range';
        this.l4x_1 = 'Referer';
        this.m4x_1 = 'Retry-After';
        this.n4x_1 = 'Schedule-Reply';
        this.o4x_1 = 'Schedule-Tag';
        this.p4x_1 = 'Sec-WebSocket-Accept';
        this.q4x_1 = 'Sec-WebSocket-Extensions';
        this.r4x_1 = 'Sec-WebSocket-Key';
        this.s4x_1 = 'Sec-WebSocket-Protocol';
        this.t4x_1 = 'Sec-WebSocket-Version';
        this.u4x_1 = 'Server';
        this.v4x_1 = 'Set-Cookie';
        this.w4x_1 = 'SLUG';
        this.x4x_1 = 'Strict-Transport-Security';
        this.y4x_1 = 'TE';
        this.z4x_1 = 'Timeout';
        this.a4y_1 = 'Trailer';
        this.b4y_1 = 'Transfer-Encoding';
        this.c4y_1 = 'Upgrade';
        this.d4y_1 = 'User-Agent';
        this.e4y_1 = 'Vary';
        this.f4y_1 = 'Via';
        this.g4y_1 = 'Warning';
        this.h4y_1 = 'WWW-Authenticate';
        this.i4y_1 = 'Access-Control-Allow-Origin';
        this.j4y_1 = 'Access-Control-Allow-Methods';
        this.k4y_1 = 'Access-Control-Allow-Credentials';
        this.l4y_1 = 'Access-Control-Allow-Headers';
        this.m4y_1 = 'Access-Control-Request-Method';
        this.n4y_1 = 'Access-Control-Request-Headers';
        this.o4y_1 = 'Access-Control-Expose-Headers';
        this.p4y_1 = 'Access-Control-Max-Age';
        this.q4y_1 = 'X-Http-Method-Override';
        this.r4y_1 = 'X-Forwarded-Host';
        this.s4y_1 = 'X-Forwarded-Server';
        this.t4y_1 = 'X-Forwarded-Proto';
        this.u4y_1 = 'X-Forwarded-For';
        this.v4y_1 = 'X-Forwarded-Port';
        this.w4y_1 = 'X-Request-ID';
        this.x4y_1 = 'X-Correlation-ID';
        this.y4y_1 = 'X-Total-Count';
        this.z4y_1 = 'Last-Event-ID';
        var tmp = this;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.a4z_1 = ['Transfer-Encoding', 'Upgrade'];
        this.b4z_1 = asList(this.a4z_1);
      }
      c4z(name) {
        // Inline function 'kotlin.text.forEachIndexed' call
        var index = 0;
        var inductionVariable = 0;
        while (inductionVariable < charSequenceLength(name)) {
          var item = charSequenceGet(name, inductionVariable);
          inductionVariable = inductionVariable + 1 | 0;
          var _unary__edvuaz = index;
          index = _unary__edvuaz + 1 | 0;
          if (Char__compareTo_impl_ypi4mb(item, _Char___init__impl__6a9atx(32)) <= 0 || isDelimiter(item)) {
            throw IllegalHeaderNameException().n4z(name, _unary__edvuaz);
          }
        }
      }
      d4z(value) {
        // Inline function 'kotlin.text.forEachIndexed' call
        var index = 0;
        var inductionVariable = 0;
        while (inductionVariable < charSequenceLength(value)) {
          var item = charSequenceGet(value, inductionVariable);
          inductionVariable = inductionVariable + 1 | 0;
          var _unary__edvuaz = index;
          index = _unary__edvuaz + 1 | 0;
          if (Char__compareTo_impl_ypi4mb(item, _Char___init__impl__6a9atx(32)) < 0 && !(item === _Char___init__impl__6a9atx(9))) {
            throw IllegalHeaderValueException().u4z(value, _unary__edvuaz);
          }
        }
      }
    }
    initMetadataForObject($, 'HttpHeaders');
    HttpHeadersClass = $;
  }
  return HttpHeadersClass;
}
var HttpHeaders_instance;
function HttpHeaders_getInstance() {
  if (HttpHeaders_instance === VOID)
    new (HttpHeaders())();
  return HttpHeaders_instance;
}
var UnsafeHeaderExceptionClass;
function UnsafeHeaderException() {
  if (UnsafeHeaderExceptionClass === VOID) {
    class $ extends IllegalArgumentException() {
      static z4z(header) {
        var $this = this.s2('Header(s) ' + header + ' are controlled by the engine and ' + 'cannot be set explicitly');
        captureStack($this, $this.y4z_1);
        return $this;
      }
    }
    initMetadataForClass($, 'UnsafeHeaderException');
    UnsafeHeaderExceptionClass = $;
  }
  return UnsafeHeaderExceptionClass;
}
function isDelimiter(ch) {
  return contains('"(),/:;<=>?@[\\]{}', ch);
}
var IllegalHeaderNameExceptionClass;
function IllegalHeaderNameException() {
  if (IllegalHeaderNameExceptionClass === VOID) {
    class $ extends IllegalArgumentException() {
      static n4z(headerName, position) {
        var tmp = "Header name '" + headerName + "' contains illegal character '" + toString(charCodeAt(headerName, position)) + "'";
        // Inline function 'kotlin.code' call
        var this_0 = charCodeAt(headerName, position);
        var tmp$ret$0 = Char__toInt_impl_vasixd(this_0);
        var $this = this.s2(tmp + (' (code ' + (tmp$ret$0 & 255) + ')'));
        captureStack($this, $this.m4z_1);
        $this.k4z_1 = headerName;
        $this.l4z_1 = position;
        return $this;
      }
    }
    initMetadataForClass($, 'IllegalHeaderNameException');
    IllegalHeaderNameExceptionClass = $;
  }
  return IllegalHeaderNameExceptionClass;
}
var IllegalHeaderValueExceptionClass;
function IllegalHeaderValueException() {
  if (IllegalHeaderValueExceptionClass === VOID) {
    class $ extends IllegalArgumentException() {
      static u4z(headerValue, position) {
        var tmp = "Header value '" + headerValue + "' contains illegal character '" + toString(charCodeAt(headerValue, position)) + "'";
        // Inline function 'kotlin.code' call
        var this_0 = charCodeAt(headerValue, position);
        var tmp$ret$0 = Char__toInt_impl_vasixd(this_0);
        var $this = this.s2(tmp + (' (code ' + (tmp$ret$0 & 255) + ')'));
        captureStack($this, $this.t4z_1);
        $this.r4z_1 = headerValue;
        $this.s4z_1 = position;
        return $this;
      }
    }
    initMetadataForClass($, 'IllegalHeaderValueException');
    IllegalHeaderValueExceptionClass = $;
  }
  return IllegalHeaderValueExceptionClass;
}
//region block: exports
export {
  HttpHeaders_getInstance as HttpHeaders_getInstance1z5nmwg0t7mku,
  UnsafeHeaderException as UnsafeHeaderException3ncvrrp48xjzq,
};
//endregion

//# sourceMappingURL=HttpHeaders.mjs.map
